const validationService = {
  isValidEmail(val) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(val)
  },
  isValidPhone(val) {
    const re = /(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -]*\d+)*$/
    return re.test(val)
  },
  isValidNumber(val) {
    const strippedCommas = val.replace(/,/g, '')
    return /^[0-9]+$/.test(strippedCommas)
  },
  isValidPercentage(val) {
    return /^[0-9][0-9]?$|^100$/.test(val)
  },
}

export default validationService
